import React, { createContext, useState, useContext, useEffect } from 'react';
import { message } from 'antd';
import api from '../utils/api';

const AuthContext = createContext(null);

export const AuthProvider = ({ children }) => {
  const [user, setUser] = useState(null);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    // 检查本地存储的token
    const token = localStorage.getItem('access_token');
    if (token) {
      fetchUserInfo();
    } else {
      setLoading(false);
    }
  }, []);

  const fetchUserInfo = async () => {
    try {
      const response = await api.get('/auth/me');
      setUser(response.data);
    } catch (error) {
      console.error('Failed to fetch user info:', error);
      logout();
    } finally {
      setLoading(false);
    }
  };

  const login = async (username, password) => {
    try {
      console.log('开始登录请求:', { username, password });
      
      const response = await api.post('/auth/login', {
        username,
        password
      });

      console.log('登录响应:', response.data);
      
      const { access_token, refresh_token } = response.data;
      localStorage.setItem('access_token', access_token);
      localStorage.setItem('refresh_token', refresh_token);

      await fetchUserInfo();
      message.success('登录成功');
      return true;
    } catch (error) {
      console.error('Login failed:', error);
      console.error('Error response:', error.response);
      console.error('Error request:', error.request);
      console.error('Error message:', error.message);
      console.error('Error config:', error.config);
      
      if (error.response) {
        console.error('Response status:', error.response.status);
        console.error('Response data:', error.response.data);
        console.error('Response headers:', error.response.headers);
      }
      
      // 处理错误信息
      let errorMessage = '登录失败';
      if (error.response?.data?.detail) {
        // 如果是数组格式的错误信息（如 Pydantic 验证错误）
        if (Array.isArray(error.response.data.detail)) {
          const errors = error.response.data.detail;
          errorMessage = errors.map(err => err.msg).join(', ');
        } else {
          errorMessage = error.response.data.detail;
        }
      }
      message.error(errorMessage);
      return false;
    }
  };

  const logout = () => {
    localStorage.removeItem('access_token');
    localStorage.removeItem('refresh_token');
    setUser(null);
    message.success('已退出登录');
  };

  const hasPermission = (permission) => {
    if (!user) return false;
    if (user.is_superuser) return true;
    
    const permissionsMap = {
      'super_admin': ['all'],
      'manager': ['campaign_manage', 'template_manage', 'view_report'],
      'material_admin': ['material_manage', 'view_report'],
      'analyst': ['view_report']
    };
    
    const userPermissions = permissionsMap[user.role] || [];
    return userPermissions.includes('all') || userPermissions.includes(permission);
  };

  return (
    <AuthContext.Provider value={{ user, login, logout, hasPermission, loading }}>
      {children}
    </AuthContext.Provider>
  );
};

export const useAuth = () => {
  const context = useContext(AuthContext);
  if (!context) {
    throw new Error('useAuth must be used within an AuthProvider');
  }
  return context;
};
